import { useTranslation } from 'react-i18next';

export const keyPrefix = 'full_frame_detections_with_settings';
export const useFullFrameDetectionsWithSettingsTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Лицо и тело',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Face and body',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Rosto e corpo',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    settings: {
      face_and_body: 'Rostro y cuerpo',
    },
  },
}) : {}) as Record<string, unknown>;
